import { saveAs } from "file-saver";

export function saveFile(file: Blob, filename: string) {
  let linkElement = document.createElement("a");

  linkElement.href = window.URL.createObjectURL(file);
  linkElement.download = filename;
  linkElement.click();
}

export function getInvoiceFilename(invoiceId: number, blob: Blob): string {
  const extension = blob.type === "application/zip" ? "zip" : "pdf";
  return `invoice-${invoiceId}.${extension}`;
}
